module.exports = __webpack_public_path__ + "media/images/settings-8f3a1f0aa2636c92c82f43074bd7dbb7.svg";